// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import urls from  '@src/@core/auth/jwt/urls'
// ** Axios Imports
import axios from 'axios'

export const getCostCenter = createAsyncThunk('appTemplates/getCostCenter', async (params) => {
    const instanceCostCenter = axios.create({
        baseURL: urls.url,
        timeout: 5000,
        headers: {Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "application/json"}
    })
    const response = await instanceCostCenter.get(`/customers/cost_center/`, {params: {p:params.page, search:params.query, page_size:params.page_size}})
    return response
})

export const createCostCenter = createAsyncThunk('appTemplates/createCostCenter', async (params, { dispatch }) => {
    const instanceCostCenter = axios.create({
        baseURL: urls.url,
        timeout: 5000,
        headers: {Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "application/json"}
    })
    const response = await instanceCostCenter.post(`/customers/cost_center/`, params.data)
    await dispatch(getCostCenter(params.getData))
    return response.data
})

export const updateCostCenter = createAsyncThunk('appTemplates/updateCostCenter', async (params, { dispatch }) => {
    const instanceCostCenter = axios.create({
        baseURL: urls.url,
        timeout: 5000,
        headers: {Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "application/json"}
    })
    await instanceCostCenter.patch(`/customers/cost_center/${params.id}/`, params.data)
    await dispatch(getCostCenter(params.getData))
    return params.id
})

export const deleteCostCenter = createAsyncThunk('appTemplates/deleteCostCenter', async (params, { dispatch }) => {
    const instanceCostCenter = axios.create({
        baseURL: urls.url,
        timeout: 5000,
        headers: {Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "application/json"}
    })
    await instanceCostCenter.delete(`/customers/cost_center/${params.id}/`)
    await dispatch(getCostCenter(params.getData))
    return params.id
})


export const appCostCenterSlice = createSlice({
    name: 'appCostCenter',
    initialState: {
        allData: [],
        total: 1,
        loading: false,
        error: null
    },
    reducers: {}, // Corregido: era 'reducer'
    extraReducers: builder => {
        builder
            .addCase(getCostCenter.pending, (state) => {
                state.loading = true
                state.error = null
            })
            .addCase(getCostCenter.fulfilled, (state, action) => {
                state.allData = action.payload.data?.results || []
                state.total = action.payload.data?.count || 0
                state.loading = false
            })
            .addCase(getCostCenter.rejected, (state, action) => {
                state.loading = false
                state.error = action.error.message
            })
    }
})

export default appCostCenterSlice.reducer
